import * as React from 'react';
import { Bem, addClass } from '../../utils/css.js';
import '../../constants.js';
import { useId } from '../../utils/hooks/useId.js';
import './Icon.scss.js';

const bem = Bem.create("vai-icon");
function Icon({ name, color, size, className, onClick, htmlId, dataTa, style, ...rest }) {
  const id = useId(htmlId, ["icon"]);
  const colorStyle = color ? { color } : void 0;
  const iconClass = addClass(bem.block(name, size), className);
  const iconStyle = colorStyle || style ? { ...style, ...colorStyle } : void 0;
  return /* @__PURE__ */ React.createElement("span", {
    style: iconStyle,
    id: id.toString(),
    "data-ta": dataTa,
    className: iconClass,
    onClick,
    ...rest
  });
}

export { Icon };
